import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const GenericNotFound = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "suggestion-item",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "hubspot-prosemirror.generic.resultsZeroState.text"
    })
  });
};